import PropTypes from 'prop-types'
import { Collapse } from 'react-collapse'
import React, { useCallback, useState } from 'react'

import Videos from './Videos'
import Portfolio from './Portfolio'
import Polaroids from './Polaroids'
import Covers from './Covers'
import Bio from './Bio'

import s from './ModelContent.module.css'
import useWindowSize from '../../hooks/useWindowSize'

function ModelContent({ allContent, fallbackImg, ...props }) {
  const content = (id, name, positionCounter, children) => {
    // Now that bio comes first, we have to make sure that portfolio is always opened
    const initialState = id === 'portfolio'
    const [isButtonCollapseOpen, setIsButtonCollapseOpen] =
      useState(initialState)
    const onClick = useCallback(
      () => setIsButtonCollapseOpen(!isButtonCollapseOpen),
      [isButtonCollapseOpen]
    )

    const windowSize = useWindowSize()
    const isMobile = windowSize?.width < 900

    const isOpened = !isMobile || isButtonCollapseOpen

    return (
      <div id={id} className={s.row} key={positionCounter.toString()}>
        <h2 className={s.title} onClick={onClick}>
          {name}
          <span aria-hidden={true} className={s.expander}>
            {isButtonCollapseOpen ? '+' : '-'}
          </span>
        </h2>

        <Collapse isOpened={isOpened}>{children}</Collapse>
      </div>
    )
  }

  let positionCounter = 0
  return (
    <div className={s.container}>
      {allContent.map((contentItem) => {
        let component = null
        if (contentItem.type === 'bio') {
          component = <Bio {...props} bio={contentItem.bio} />
        } else if (contentItem.type === 'polaroids') {
          component = <Polaroids {...props} images={contentItem.assets} />
        } else if (contentItem.type === 'covers') {
          component = <Covers {...props} images={contentItem.assets} />
        } else if (contentItem.type === 'campaigns') {
          component = (
            <Portfolio
              {...props}
              images={contentItem.assets}
              fallbackImg={false}
              customBook={true}
            />
          )
        } else if (contentItem.type === 'video') {
          component = <Videos {...props} videos={contentItem.assets} />
        } else if (contentItem.type === 'books') {
          if (contentItem.slug === 'video' || contentItem.slug === 'videos') {
            component = <Videos {...props} videos={contentItem.assets} />
          } else {
            component = <Portfolio {...props} images={contentItem.assets} />
          }
        } else if (contentItem.type === 'portfolio') {
          component = (
            <Portfolio
              {...props}
              images={contentItem.assets}
              fallbackImg={fallbackImg}
            />
          )
        } else {
          // Always fall back to Portfolio component if there isn't a specific one
          component = <Portfolio {...props} images={contentItem.assets} />
        }

        return content(
          contentItem.scrollSpyId,
          contentItem.typeName,
          positionCounter++,
          component
        )
      })}
    </div>
  )
}

ModelContent.propTypes = {
  allContent: PropTypes.array,
  fallbackImg: PropTypes.bool,
}
ModelContent.defaultProps = {
  allContent: [],
  fallbackImg: false,
}

export default ModelContent
